// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@200;300;400;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*================ google fonts ================*/

/*================ base style ================*/
* {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    font-family: "Source Sans 3", sans-serif;
}

/*============== pre-define css ==============*/
h1, h2, h3, h4, h5, h6 {
    color: #03A5D5;
    font-weight: 600;
    margin-bottom: 0;
}
h3, h4 {
    font-size: 1.8rem;
}
h5, h6 {
    font-size: 0.9rem;
}
a {
    text-decoration: none;
    color: unset;
}
a:hover {
    color: unset;
}
ul {
    margin: 0;
    list-style: none;
}
.section__title {
    color: #03A5D5;
    font-weight: 600;
    font-size: 2rem;
}
.section__subtitle {
    color: #FF7F50;
    font-weight: 600;
    font-size: 1.2rem;
}
.section__description {
    color: #494d50;
    font-size: .9rem;
    line-height: 30px;
}
section {
    padding: 20px 0px;
}
.btn {
    padding: 7px 15px;
    background: #03A5D5;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 5px;
    transition: .3s;
}
.btn:hover {
    color: #fff!important;
    background: #FF7F50!important;
}
.btn:disabled {
    color: #fff!important;
    background: #FF7F50!important;
    pointer-events: none;
  }
.no-hover-effect:hover, .no-hover-effect:active {
    background-color: initial !important; /* Retain the original background color */
    color: #fff !important; /* Retain the original text color */
}
.validation__error-message {
    color: #FF7F50;
    font-size: 0.7rem;
    margin-top: 0.2rem;
}
.form-control:focus {
    outline: 0;
    box-shadow: none;
    border-color: #dee2e6;
}
@media only screen and (max-with:768px) {
    section {
        padding: 30px 30px;
    }
    .section__title {
        font-size: 1.6rem;
    }
    .section__subtitle {
        font-size: 1.1rem;
    }
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAGjD,+CAA+C;AAC/C;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA,+CAA+C;AAC/C;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,oBAAoB;EACtB;AACF;IACI,oCAAoC,EAAE,yCAAyC;IAC/E,sBAAsB,EAAE,mCAAmC;AAC/D;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/*================ google fonts ================*/\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@200;300;400;600;700;800&display=swap');\n\n/*================ base style ================*/\n* {\n    margin: 0px;\n    padding: 0px;\n    box-sizing: border-box;\n    font-family: \"Source Sans 3\", sans-serif;\n}\n\n/*============== pre-define css ==============*/\nh1, h2, h3, h4, h5, h6 {\n    color: #03A5D5;\n    font-weight: 600;\n    margin-bottom: 0;\n}\nh3, h4 {\n    font-size: 1.8rem;\n}\nh5, h6 {\n    font-size: 0.9rem;\n}\na {\n    text-decoration: none;\n    color: unset;\n}\na:hover {\n    color: unset;\n}\nul {\n    margin: 0;\n    list-style: none;\n}\n.section__title {\n    color: #03A5D5;\n    font-weight: 600;\n    font-size: 2rem;\n}\n.section__subtitle {\n    color: #FF7F50;\n    font-weight: 600;\n    font-size: 1.2rem;\n}\n.section__description {\n    color: #494d50;\n    font-size: .9rem;\n    line-height: 30px;\n}\nsection {\n    padding: 20px 0px;\n}\n.btn {\n    padding: 7px 15px;\n    background: #03A5D5;\n    color: #fff;\n    border: none;\n    outline: none;\n    border-radius: 5px;\n    transition: .3s;\n}\n.btn:hover {\n    color: #fff!important;\n    background: #FF7F50!important;\n}\n.btn:disabled {\n    color: #fff!important;\n    background: #FF7F50!important;\n    pointer-events: none;\n  }\n.no-hover-effect:hover, .no-hover-effect:active {\n    background-color: initial !important; /* Retain the original background color */\n    color: #fff !important; /* Retain the original text color */\n}\n.validation__error-message {\n    color: #FF7F50;\n    font-size: 0.7rem;\n    margin-top: 0.2rem;\n}\n.form-control:focus {\n    outline: 0;\n    box-shadow: none;\n    border-color: #dee2e6;\n}\n@media only screen and (max-with:768px) {\n    section {\n        padding: 30px 30px;\n    }\n    .section__title {\n        font-size: 1.6rem;\n    }\n    .section__subtitle {\n        font-size: 1.1rem;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
